import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/material components
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

// @mui/icons-material
// core components
import GridContainer from "/components/Grid/GridContainer.js";
import GridItem from "/components/Grid/GridItem.js";
import CustomInput from "/components/CustomInput/CustomInput.js";
import Button from "/components/CustomButtons/Button.js";
import axios from 'axios';
import styles from "../services/ServicesSections.module.scss";





export default function SectionContact() {
  const [specialitySelect, setSpecialitySelect] = React.useState("0");
  const handleSpeciality = (event) => {
    setSpecialitySelect(event.target.value);
  };
  const classes = styles;

  const getClientId = () => {
    var gaCookie = document.cookie.split('; ').find(row => row.startsWith('_ga='));
    if (!gaCookie) return ''; 
    var gaCookieValue = gaCookie.split('=')[1];
    // GA4 cookie format: GA1.2.XXXXXXXXXX.YYYYYYYYYY
    var clientId = gaCookieValue.split('.').slice(-2).join('.');
    return clientId;
  };

  // UseEffect to set clientId in state upon component mount
  useEffect(() => {
    const currentClientId = getClientId(); 
    setInputs(prev => ({
      ...prev,
      clientId: currentClientId,
    }));
  }, []); 

  {/* New Form Functions */}
  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null },
  });
  const [inputs, setInputs] = useState({
    yourName: '',
    emailAddress: '',
    clientId: '',
    phone: '',
    message: '',
    specialityselect: '',
  });
  const handleServerResponse = (ok, msg) => {
    if (ok) {
      setStatus({
        submitted: true,
        submitting: false,
        info: { error: false, msg: msg },
      });
      setInputs({
        yourName: '',
        emailAddress: '',
        clientId: '',
        phone: '',
        message: '',
        specialityselect: '',
      });
    } else {
      setStatus({
        info: { error: true, msg: msg },
      });
    }
  };
  const handleOnChange = (e) => {
    e.persist();
    setInputs((prev) => ({
      ...prev,
      [e.target.id]: e.target.value,
    }));
    setStatus({
      submitted: false,
      submitting: false,
      info: { error: false, msg: null },
    });
  };
  const handleOnSubmit = (e) => {
    e.preventDefault();
    setStatus((prevStatus) => ({ ...prevStatus, submitting: true }));
    axios({
      method: 'POST',
      url: 'https://formspree.io/f/xoqgkpjb',
      data: inputs,
    })
      .then((response) => {
        handleServerResponse(
          true,
          'Thank you, your message has been submitted.',
        );
      })
      .catch((error) => {
        handleServerResponse(false, error.response.data.error);
      });
  };


  return (
    <div className={classes.aboutUs}>
      <GridContainer justifyContent='center'>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h2 className={classNames(classes.title, classes.textCenter)}>
            Want to work with us?
          </h2>
          <h4 className={classNames(classes.description, classes.textCenter)}>
           Hey there! Like what you see here? Want to find out more? Fill out the form below...
          </h4>
          <form onSubmit={handleOnSubmit}>
            <GridContainer>
              <GridItem md={4} sm={4}>
                <CustomInput
                  labelText="Your name"
                  id="yourName"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: handleOnChange,
                  }}
                />
              </GridItem>
              <GridItem md={4} sm={4}>
                <CustomInput
                  labelText="Your email"
                  id="emailAddress"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: handleOnChange,
                  }}
                />
              </GridItem>
              <input
			          type="hidden"
			          name="clientId" 
			          value={inputs.clientId}
                  />
              <GridItem md={4} sm={4}>
                <FormControl
                  fullWidth
                  className={
                    classes.selectFormControl +
                    " " +
                    classes.selectUnderlineRoot
                  }
                >
                  <Select
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    classes={{
                      select: classes.select
                    }}
                    value={specialitySelect}
                    onChange={handleSpeciality}
                    inputProps={{
                      name: "specialitySelect",
                      id: "speciality-select"
                    }}
                  >
                    <MenuItem
                      disabled
                      classes={{
                        root: classes.selectMenuItem
                      }}
                      value="0"
                    >
                      Speciality
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="1"
                    >
                      I{"'"}m a Designer
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="2"
                    >
                      I{"'"}m a Developer
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="3"
                    >
                      I{"'"}m a Data Scientist
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                      value="4"
                    >
                      I{"'"}m an Analyst
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                      value="5"
                    >
                      I{"'"}m a Marketing Specialist
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                      value="6"
                    >
                      I{"'"}m a Business Owner
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                      value="7"
                    >
                      I{"'"}m a Potential Client
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                      value="8"
                    >
                      I{"'"}ve just Got a Question
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                      value="9"
                    >
                      I{"'"}m a Hero
                    </MenuItem>
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem>
              <CustomInput
                    labelText="Your message"
                    id="message"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      multiline: true,
                      rows: 3,
                      onChange: handleOnChange,
                    }}
                  />
              </GridItem>
            </GridContainer>
            <GridContainer justifyContent="center">
              <GridItem
                md={4}
                sm={4}
                className={classNames(
                  classes.mrAuto,
                  classes.mlAuto,
                  classes.textCenter
                )}
              >
                <Button color="primary" round className={classes.pullRight} type="submit" disabled={status.submitting} onClick={() => {!status.submitting ? !status.submitted ? 'Submit' : 'Submitted' : 'Submitting...'}}>
                  Let{"'"}s talk
                </Button>
              </GridItem>
            </GridContainer>
          </form>
          {status.info.error && (
            <div className="error">Error: {status.info.msg}</div>
            )}
          {!status.info.error && status.info.msg && <p>{status.info.msg}</p>}
        </GridItem>
      </GridContainer>
    </div>
  );
}
